import { Swiper, SwiperSlide } from "swiper/react";
import { useBreakpoint } from "hooks/useBreakpoint";
import LoyaltyLevelRewardButton from "components/molecules/LoyaltyLevelRewardButton";
import { LoyaltyLevelRewardButtonProps } from "components/molecules/LoyaltyLevelRewardButton/types";
import { Swiper as SwiperClass } from "swiper/types";
import "./styles.sass";

type LoyaltyListRanksProps = {
  activeIndex: number;
  onClickCard: (index: number) => void;
  ranks?: LoyaltyLevelRewardButtonProps[];
};

const LoyaltyListRanks = (props: LoyaltyListRanksProps) => {
  const { activeIndex, ranks = [], onClickCard } = props;
  const { isPhone } = useBreakpoint();

  const handleSwipe = (swiper: SwiperClass) => {
    if (isPhone) {
      onClickCard(swiper.realIndex);
    }
  };

  const onClick = (index: number) => {
    if (!isPhone) {
      onClickCard(index);
    }
  };

  if (ranks.length === 0) {
    return null;
  }

  return (
    <div className="LoyaltyListRanks">
      <Swiper
        spaceBetween={12}
        slidesPerView="auto"
        grabCursor
        className="LoyaltyListRanks__swiper"
        centeredSlides={isPhone}
        onSlideChange={handleSwipe}
      >
        {ranks?.map((rank) => (
          <SwiperSlide key={rank.nameRank} className="LoyaltyListRanks__slide">
            <LoyaltyLevelRewardButton
              {...rank}
              active={activeIndex === rank.indexRank}
              handleClick={() => onClick(rank.indexRank)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default LoyaltyListRanks;
